function sorguDizgesi(sorgu) {
    const params = new URLSearchParams();
    if (sorgu.sayfa)
        params.set('sayfa', String(sorgu.sayfa));
    if (sorgu.boyut)
        params.set('boyut', String(sorgu.boyut));
    if (sorgu.arama)
        params.set('arama', sorgu.arama);
    if (sorgu.noktaId)
        params.set('noktaId', sorgu.noktaId);
    if (sorgu.durum)
        params.set('durum', sorgu.durum);
    const s = params.toString();
    return s ? `?${s}` : '';
}
export async function dolaplariListele(istemci, sorgu = {}) {
    return istemci.istek(`/dolaplar${sorguDizgesi(sorgu)}`);
}
export async function dolapGetir(istemci, id) {
    return istemci.istek(`/dolaplar/${id}`);
}
export async function dolapOlustur(istemci, giris) {
    return istemci.istek('/dolaplar', { method: 'POST', body: JSON.stringify(giris) });
}
export async function dolapGuncelle(istemci, id, giris) {
    return istemci.istek(`/dolaplar/${id}`, { method: 'PUT', body: JSON.stringify(giris) });
}
export async function dolapSil(istemci, id) {
    await istemci.istek(`/dolaplar/${id}`, { method: 'DELETE' });
}
export async function dolapZorlaSifirla(istemci, id, sebep, yeniDurum = 'MUSAIT') {
    return istemci.istek(`/dolaplar/${id}/zorla-sifirla`, {
        method: 'POST',
        body: JSON.stringify({ sebep, yeniDurum }),
    });
}
export async function dolapTopluUret(istemci, giris) {
    return istemci.istek('/dolaplar/toplu-uret', {
        method: 'POST',
        body: JSON.stringify(giris),
    });
}
export async function dolapTopluGuncelle(istemci, giris) {
    return istemci.istek('/dolaplar/toplu', {
        method: 'PATCH',
        body: JSON.stringify(giris),
    });
}
//# sourceMappingURL=dolaplar.js.map